import { render } from "./channel.vue?vue&type=template&id=06b6bf52&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"

import "./channel.vue?vue&type=style&index=0&id=06b6bf52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b6bf52"]])

export default __exports__